const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const userReducer = (state = {}, action) => {
  switch (action.type) {
    case 'RESET_USER_STATUS': {
      const { [action.payload]: key, ...rest } = state.status
      return !key
        ? state
        : {
            ...state,
            status: {
              ...rest,
            },
          }
    }
    case 'USER_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_USER_CSAT':
      return {
        ...state,
        status: {
          get_user_csat: {
            ...initialStatus,
            loading: true,
          },
        },
      }
    case 'SET_USER_CSAT':
      return {
        ...state,
        csat: { ...action.payload },
        status: {
          get_user_csat: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'SET_USER':
      return action.payload
    default:
      return state
  }
}

export default userReducer
